import { Swiper, Navigation, Pagination, Autoplay, EffectFade } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let accommodationsSlide = new Swiper(".accommodations__slide", {
        watchOverflow: true,
        slidesPerView: 1,
        navigation: {
            nextEl: ".accommodations__right",
            prevEl: ".accommodations__left",
        },
    });

    let rowsRightSlider = new Swiper(".rows-right", {
        slidesPerView: 5,
        loop: true,
        speed: 5000,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
        },
    });

    let rowsLeftSlider = new Swiper(".rows-left", {
        slidesPerView: 5,
        loop: true,
        speed: 5000,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
            reverseDirection: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
        },
    });

    let recreationSlide = new Swiper(".recreation__slide", {
        watchOverflow: true,
        slidesPerView: 1,
        navigation: {
            nextEl: ".recreation__right",
            prevEl: ".recreation__left",
        },
    });

    let banner = new Swiper(".banner__slider", {
        watchOverflow: true,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let video = new Swiper(".video__slider", {
        watchOverflow: true,
        autoplay: {
            delay: 5000,
        },
        effect: "fade",
        speed: 4000,
        allowSlideNext: false,
        allowSlidePrev: false,
        allowTouchMove: false,
    });

    let servicesSlide = new Swiper(".services__slide", {
        watchOverflow: true,
        slidesPerView: 1,
        navigation: {
            nextEl: ".services__right",
            prevEl: ".services__left",
        },
    });

    let packageSlider = new Swiper(".package__swiper", {
        watchOverflow: true,
        navigation: {
            nextEl: ".package-button-next",
            prevEl: ".package-button-prev",
        },
        pagination: {
            el: ".package-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let citySlide = new Swiper(".city__slide", {
        watchOverflow: true,
        slidesPerView: 1,
        navigation: {
            nextEl: ".city__right",
            prevEl: ".city__left",
        },
    });

    let menuSlider = new Swiper(".menu__swiper", {
        watchOverflow: true,
        navigation: {
            nextEl: ".menu-button-next",
            prevEl: ".menu-button-prev",
        },
        pagination: {
            el: ".menu-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let restaurantsSlider = new Swiper(".restaurants-slider__swiper", {
        watchOverflow: true,
        allowTouchMove: false,
        spaceBetween: 10,
        slidesPerView: 1,
        freeMode: false,
        navigation: {
            nextEl: ".restaurants-slider-button-next",
            prevEl: ".restaurants-slider-button-prev",
        },
    });

    document.querySelectorAll(".restaurants .tab-header-item").forEach(slider => {
        slider.addEventListener("click", () => {
            let restaurantSliderUpdate = new Swiper(".restaurants-slider__swiper", {
                watchOverflow: true,
                spaceBetween: 10,
                slidesPerView: 1,
                allowTouchMove: false,
                navigation: {
                    nextEl: ".restaurants-slider-button-next",
                    prevEl: ".restaurants-slider-button-prev",
                },
            });
        });
    });
    
    let placesSlide = new Swiper(".places__slide", {
        watchOverflow: true,
        slidesPerView: 1,
        navigation: {
            nextEl: ".places__right",
            prevEl: ".places__left",
        },
    });
    
    let highlightSlide = new Swiper(".highlight__slide", {
        watchOverflow: true,
        slidesPerView: 1,
        navigation: {
            nextEl: ".highlight__right",
            prevEl: ".highlight__left",
        },
        pagination: {
            el: ".highlight__pagination",
            clickable: true,
        },
    });

    let quoteSlide = new Swiper(".quote__slide", {
        slidesPerView: 1,
        watchOverflow: true,
        navigation: {
            nextEl: ".quote__right",
            prevEl: ".quote__left",
        },
    });
};
